import { createQueryKeys } from "@lukemorales/query-key-factory";
import { IDropdownModel } from "common/models/IDropdownModel";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { instituteView } from "../types/instituteView";
import { IInstitute, IInstituteGridFilter, IInstituteGridModel } from "./types";
import { PostModel } from "common/models/BaseModel";
import { IListResponse } from "common/models/GridModels";

export const institute = createQueryKeys("institute", {
  list: (postModel: PostModel<IInstituteGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<IListResponse<IInstituteGridModel>>(
        endpoints.institute.list,
        postModel
      ),
  }),

  getById: (Id: string | number) => ({
    queryKey: [Id],
    queryFn: () => api.get<IInstitute>(`${endpoints.institute.getById}/${Id}`),
  }),

  getInstituteValues: () => ({
    queryKey: ["GetInstituteValues"],
    queryFn: () =>
      api.get<IDropdownModel[]>(endpoints.institute.getInstituteValues),
  }),

  getViewById: (Id: string | number) => ({
    queryKey: ["modal", Id],
    queryFn: () => api.get<instituteView>(`${endpoints.institute.view}/${Id}`),
  }),

  getInstituteByUniverisity: (Id: string | number) => ({
    queryKey: [Id],
    queryFn: () =>
      api.get<IDropdownModel[]>(
        `${endpoints.institute.getInstituteByUniverisity}/${Id}`
      ),
  }),

  getInstituteByLibrary: () => ({
    queryKey: ["getInstituteByLibrary"],
    queryFn: () =>
      api.get<IDropdownModel[]>(endpoints.institute.getInstituteByLibrary),
  }),
});
